import React from 'react';
import AppButton from '../../../components/AppButton/AppButton';
import { useEffect, useState } from 'react';
import { getVerifiedSuppliers } from '../../../services/supplierService';
import { toast } from 'react-toastify';
import { GoodsSearchProps } from '../../../types/interfaces';
import { useNavigate } from 'react-router-dom';

interface SupplierData {
  logo: string;
  name: string;
  verified: string;
  rating: number;
  reviews: number;
  services: string[];
  products: {
    image: string;
    price: string;
  }[];
}

interface VerifiedSupplierData {
  companyId: string;
  businessName: string;
  status: string;
  ratings: number;
  review: number;
  productImages: string[];
}

const VerifiedSuppliers: React.FC<GoodsSearchProps> = ({ searchProps }) => {
  const [verifiedSuppliers, setVerifiedSuppliers] = useState<VerifiedSupplierData[]>([]);
  const navigate = useNavigate();

  const fetchVerifiedSuppliers = async () => {
    try {
      const response = await getVerifiedSuppliers();
      if (response.isSuccess) {
        setVerifiedSuppliers(response?.data);
      } else {
        toast.error(response.errorMessage);
      }
    } catch (error) {
      console.error('Error fetching verified suppliers:', error);
    }
  };

  const viewProfile = (companyId: string) => {
    navigate('/settings/supplier-profile', { state: { companyId: companyId } });
  };

  useEffect(() => {
    fetchVerifiedSuppliers();
  }, [searchProps]);

  return (
    <>
      {verifiedSuppliers &&
        verifiedSuppliers.map((supplier, index) => (
          <div key={index} className="mb-6 w-full rounded-lg bg-white px-3 py-4">
            <div className="mb-6 flex items-center justify-between">
              <div className="flex gap-3">
                <div>
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/${supplier.companyId}.png`}
                    alt={supplier.businessName}
                    className={`h-16 w-full rounded-t-lg object-cover`}
                  />
                </div>
                <div>
                  <h2 className="text-xl text-gray-700 underline decoration-gray-700">
                    {supplier.businessName}
                  </h2>
                  <p className="mt-1 w-[50%] rounded-full border bg-green-500 text-center text-white">
                    {supplier.status}
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-5">
                <AppButton
                  title={'Chat Now'}
                  onClick={() => toast.info('Chat Now clicked')}
                  className="rounded-lg border border-gray-300 px-3 py-2 font-semibold"
                />
                {/* <AppButton
                  title={'Contact Supplier'}
                  onClick={() => toast.info('Contact Supplier clicked')}
                  className="rounded-lg border border-gray-300 px-3 py-2 font-semibold"
                /> */}
                <AppButton
                  title={'View Profile'}
                  onClick={() => viewProfile(supplier.companyId)}
                  className="rounded-lg bg-primary px-3 py-2 font-semibold"
                />
              </div>
            </div>
            <hr />
            <div className="mt-2 flex justify-between py-2">
              <div>
                <p className="mt-2 text-gray-500">Ratings & Reviews</p>
                <div className="mt-2 flex items-center text-lg">
                  <div className="flex text-yellow-500">
                    {Array.from({ length: 5 }).map((_, starIndex) => (
                      <span
                        key={starIndex}
                        className={
                          starIndex < supplier.ratings
                            ? 'text-yellow-500' // Full stars
                            : 'text-gray-400' // Empty star
                        }
                      >
                        &#9733;
                      </span>
                    ))}
                  </div>
                  <span className="ml-4 text-gray-800">({supplier.review} Reviews)</span>
                </div>
                <p className="mb-2 mt-4 text-xl font-semibold text-gray-700">Products</p>
                <div className="grid grid-cols-2 gap-3">
                  {supplier.productImages.slice(0, 4).map((image, imageIndex) => (
                    <div key={imageIndex} className="relative">
                      <img
                        src={`${process.env.PUBLIC_URL}/assets/${image}`}
                        alt={'product'}
                        className={`h-[95px] w-full rounded-t-lg object-cover`}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        ))}
    </>
  );
};

export default VerifiedSuppliers;
